/**
 * @file variantDiseasesInitialQuery.saga.js
 * @description
 *
 * @copyright veriome labs, llc.  - all rights reserved.
 * This file is subject to the terms and conditions defined in
 * file 'LICENSE.md', which is part of this source code package.
 *
 * @author don michael
 * @since April 2, 2023 02:38 PM
 */
import { call, put, takeLatest } from 'redux-saga/effects';
import axiosClient from 'src/services/axiosClient.js';

import {
    VARIANT_DISEASES_INITIAL_QUERY_REQUEST,
    variantDiseasesInitialQuerySuccess,
    variantDiseasesInitialQueryFailure,
} from 'src/store/actions/variant/variantDb.actions';

import { dataLoadingSet } from 'src/store/actions/global.actions';
import handleSagaErrors from 'src/store/sagas/handleSagaErrors';

function callApi(payload) {
    const url = '/variant/variantDiseases/initialQuery';

    const baseUrl = import.meta.env.VITE_APP_API_BASE_URL;

    const config = {
        method: 'post',
        baseURL: baseUrl,
        url,
        data: {
            variantId: payload.variantId,
            pageSize: payload.pageSize,
        },

    };

    return new Promise((resolve, reject) => {
        axiosClient(config)
            .then((response) => {
                resolve(response.data);
            })
            .catch((err) => {
                reject(err);
            });
    });
}

function* searchRequestSaga(action) {

    try {
        yield put(dataLoadingSet(true));

        const resp = yield call(callApi, action.payload);
        yield put(variantDiseasesInitialQuerySuccess(resp.payload));

    } catch (error) {
        yield put(variantDiseasesInitialQueryFailure(error));
        handleSagaErrors(error);
    } finally {
        yield put(dataLoadingSet(false));
    }

}

export default function* searchRequestMonitor() {
    yield takeLatest(VARIANT_DISEASES_INITIAL_QUERY_REQUEST, searchRequestSaga);
}
